import { graphql, useFragment } from 'react-relay';
import { getPriceFromAmountListByCurrency } from 'dibs-buyer-price/exports/getPriceFromAmountListByCurrency';

import { type useGateSoldPrice_item$key } from './__generated__/useGateSoldPrice_item.graphql';

const itemFragment = graphql`
    fragment useGateSoldPrice_item on Item {
        isSold
        displayPrice(
            isTrade: $isTrade
            buyerId: $userId
            userCountryCode: $userCountryCode
            priceBookName: $priceBookName
        ) {
            originalConvertedAmountList {
                currency
                amount
            }
            convertedAmountList {
                currency
                amount
            }
        }
    }
`;

export const useGateSoldPrice = (
    itemRef: useGateSoldPrice_item$key | null | undefined,
    currency: string
): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const { displayPrice, isSold } = item || {};
    const convertedAmountList = displayPrice?.[0]?.convertedAmountList || [];
    const originalConvertedAmountList = displayPrice?.[0]?.originalConvertedAmountList || [];

    const amountByCurrency = getPriceFromAmountListByCurrency(convertedAmountList, currency) || 0;
    const originalAmountByCurrency =
        getPriceFromAmountListByCurrency(originalConvertedAmountList, currency) || 0;

    return !!amountByCurrency && !!originalAmountByCurrency && !!isSold;
};
